var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "../themes/styled";
import Box from "../box/Box";
import { theme, prop } from "styled-tools";
import { BgImage } from "../image";
var getColor = function (bg) { return function (p) {
    if (bg.indexOf("#") !== -1) {
        return bg;
    }
    return theme("colors.".concat(bg));
}; };
var Container = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    .content {\n        background-image: ", ";\n    }\n"], ["\n    position: relative;\n    .content {\n        background-image: ", ";\n    }\n"])), prop("gradient", css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["linear-gradient(180deg, transparent 50%, ", " 90%)"], ["linear-gradient(180deg, transparent 50%, ", " 90%)"])), function (p) { return getColor(p.bg)(p); })));
export default (function (_a) {
    var children = _a.children, bgSrc = _a.bgSrc, _b = _a.bgColor, bgColor = _b === void 0 ? "grays.8" : _b, bgProps = _a.bgProps, rest = __rest(_a, ["children", "bgSrc", "bgColor", "bgProps"]);
    return (React.createElement(Container, __assign({ bg: bgColor }, rest),
        React.createElement(BgImage, __assign({ width: "100%", height: "100%", src: bgSrc, backgroundPosition: "top center", position: "absolute", top: "0", left: "0", zIndex: 0 }, bgProps)),
        React.createElement(Box, { className: "content", position: "relative", zIndex: 1 }, children)));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=BgImageGradient.js.map